import React from "react";
import { Button } from "@/components/ui/button";
import {
  UtensilsCrossed, ClipboardList, TrendingUp, DollarSign, Grid3X3,
  Users, Megaphone, UserCog, BarChart3, Monitor,
} from "lucide-react";

const MODULE_BUTTONS = [
  { label: "MENÚ", icon: UtensilsCrossed, path: "/menu", color: "border-teal-500 text-teal-600 hover:bg-teal-50" },
  { label: "PEDIDOS", icon: ClipboardList, path: "/orders", color: "border-blue-500 text-blue-600 hover:bg-blue-50" },
  { label: "VENTAS", icon: TrendingUp, path: "/financiero", color: "border-green-500 text-green-600 hover:bg-green-50" },
  { label: "FINANCIERO", icon: DollarSign, path: "/financiero", color: "border-emerald-500 text-emerald-600 hover:bg-emerald-50" },
  { label: "MESAS", icon: Grid3X3, path: "/tables", color: "border-purple-500 text-purple-600 hover:bg-purple-50" },
  { label: "CLIENTES", icon: Users, path: "/customers", color: "border-cyan-500 text-cyan-600 hover:bg-cyan-50" },
  { label: "MARKETING", icon: Megaphone, path: "/marketing", color: "border-pink-500 text-pink-600 hover:bg-pink-50" },
  { label: "EQUIPE", icon: UserCog, path: "/team", color: "border-amber-500 text-amber-600 hover:bg-amber-50" },
  { label: "REPORTES", icon: BarChart3, path: "/reports", color: "border-indigo-500 text-indigo-600 hover:bg-indigo-50" },
  { label: "KDS", icon: Monitor, path: "/kitchen", color: "border-red-500 text-red-600 hover:bg-red-50" },
];

export default function DashboardModuleButtons({ navigate }) {
  return (
    <div className="flex flex-wrap gap-2" data-testid="module-buttons">
      {MODULE_BUTTONS.map(mod => (
        <Button
          key={mod.label} variant="outline" size="sm"
          className={`gap-2 border ${mod.color} transition-colors`}
          onClick={() => navigate(mod.path)}
          data-testid={`module-btn-${mod.label.toLowerCase()}`}
        >
          <mod.icon className="w-4 h-4" />{mod.label}
        </Button>
      ))}
    </div>
  );
}
